'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = require('./Utils');

var _SubContent = require('./Utils/SubContent');

var _SubContent2 = _interopRequireDefault(_SubContent);

var _FileUpload = require('./FileUpload');

var _FileUpload2 = _interopRequireDefault(_FileUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultipleFileUpload = function (_Component) {
    _inherits(MultipleFileUpload, _Component);

    function MultipleFileUpload() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MultipleFileUpload);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultipleFileUpload.__proto__ || Object.getPrototypeOf(MultipleFileUpload)).call.apply(_ref, [this].concat(args))), _this), _this._updateValue = function (data) {
            // tell the composing component to add this file to its internal structure
            _this.props.appendValue(data[_this.props.name]);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MultipleFileUpload, [{
        key: 'render',
        value: function render() {
            var groupClasses = (0, _classnames2.default)({
                'form__group': true,
                'form__group--error': this.props.errors && this.props.errors.length
            }, this.props.extraGroupClasses);

            var existingFiles = null;

            if (this.props.value && this.props.value.length) {
                existingFiles = _react2.default.createElement(
                    'ul',
                    null,
                    this.props.value.map(function (item, index) {
                        return _react2.default.createElement(
                            'li',
                            { key: index },
                            _react2.default.createElement(
                                'a',
                                { href: item.file, target: '_blank' },
                                item.name
                            )
                        );
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: groupClasses },
                _react2.default.createElement(
                    'div',
                    { className: 'form__control' },
                    existingFiles,
                    _react2.default.createElement(_FileUpload2.default, {
                        controlOnly: true,
                        data: this.props.data,
                        disabled: this.props.disabled,
                        errorAction: this.props.errorAction,
                        name: this.props.name,
                        updateValue: this._updateValue,
                        uploadAction: this.props.uploadAction
                    })
                ),
                _react2.default.createElement(_SubContent2.default, { errors: this.props.errors, help: this.props.help })
            );
        }
    }]);

    return MultipleFileUpload;
}(_react.Component);

MultipleFileUpload.propTypes = {
    appendValue: _propTypes2.default.func.isRequired,
    data: _propTypes2.default.object,
    disabled: _Utils.formControlPropTypes.disabled,
    errorAction: _propTypes2.default.func.isRequired,
    errors: _Utils.formControlPropTypes.errors,
    help: _Utils.formControlPropTypes.help,
    name: _Utils.formControlPropTypes.name,
    uploadAction: _propTypes2.default.func.isRequired,
    value: _propTypes2.default.arrayOf(_propTypes2.default.string)
};
MultipleFileUpload.defaultProps = {
    data: {},
    disabled: false,
    errors: [],
    helpText: null,
    value: []
};
exports.default = MultipleFileUpload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cotidia/react-ui/lib/MultipleFileUpload.js
// module id = 429
// module chunks = 0